import { render, staticRenderFns } from "./preview-form-group.vue?vue&type=template&id=5a638552&scoped=true&"
import script from "./preview-form-group.vue?vue&type=script&lang=js&"
export * from "./preview-form-group.vue?vue&type=script&lang=js&"
import style0 from "./preview-form-group.vue?vue&type=style&index=0&id=5a638552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a638552",
  null
  
)

export default component.exports